































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import questionSettingTemplate from "./questionSettingTemplate.vue";
// import { phoneNumValidate } from "@modules/newCommunity/pages/operationTools/pages/questionnaireEdit/validateUtils/newIndex";
@Component({
  name: "diagnosisTime",
  components: {
    questionSettingTemplate,
  },
})
export default class diagnosisTime extends Vue {
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  value!: any;
  @Prop({
    type: Boolean,
    default: false,
  })
  disabled?: any;

  @Watch("value", { deep: true, immediate: true })
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
      this.clearValidate();
      this.$nextTick(() => {
        this.validate();
      });
    }
  }
  private postForm = {
    title: "", // 标题
    required: "1", // 是否必填
    jsonConfig: {
      showIndex: true,
      dateType: "date",
      minDateType: "",
      maxDateType: "",
      minRequirementDate: "",
      maxRequirementDate: "",
    },
  };

  private rules = {
    title: [{ required: true, message: "请输入标题", trigger: "blur" }],
    required: [{ required: true, message: "请选择是否必填", trigger: "blur" }],

    "jsonConfig.minDateType": [{ validator: this.validatorMinDateType, trigger: "blur" }],
    "jsonConfig.maxDateType": [{ validator: this.validatorMaxDateType, trigger: "blur" }],
  };
  get dateFormat() {
    let date = "yyyy-MM-dd";
    if (this.postForm.jsonConfig.dateType == "datehour") {
      date = "yyyy-MM-dd HH";
    }
    if (this.postForm.jsonConfig.dateType == "datetime") {
      date = "yyyy-MM-dd HH:mm";
    }
    return date;
  }
  @Watch("postForm", { deep: true })
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  validatorMinDateType(rule: any, value: any, callback: any) {
    if (this.postForm.jsonConfig.minDateType == "requirementDate" && !this.postForm.jsonConfig.minRequirementDate) {
      callback(new Error("请选择起始时间"));
    } else if (this.postForm.jsonConfig.minDateType == "requirementDate" && this.postForm.jsonConfig.maxDateType == "requirementDate" && new Date(this.postForm.jsonConfig.minRequirementDate) > new Date(this.postForm.jsonConfig.maxRequirementDate)) {
      callback(new Error("起始时间需小于截止时间"));
    } else {
      callback();
    }
  }
  validatorMaxDateType(rule: any, value: any, callback: any) {
    if (this.postForm.jsonConfig.maxDateType == "requirementDate" && !this.postForm.jsonConfig.maxRequirementDate) {
      callback(new Error("请选择截止时间"));
    } else if (this.postForm.jsonConfig.minDateType == "requirementDate" && this.postForm.jsonConfig.maxDateType == "requirementDate" && new Date(this.postForm.jsonConfig.minRequirementDate) > new Date(this.postForm.jsonConfig.maxRequirementDate)) {
      callback(new Error("起始时间需小于截止时间"));
    } else {
      callback();
    }
  }

  getFormInstance() {
    return this.$refs.postForm as any;
  }
  resetFields() {
    this.getFormInstance().resetFields();
  }

  async validate() {
    return await this.getFormInstance()
      .validate()
      .catch((err: any) => {
        return err;
      });
  }

  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
}
